import request, { Methods, withToken, RequestType } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_IMPORT_SERVICE_CLIENT_RESET = 'POST_IMPORT_SERVICE_CLIENT_RESET';
export const POST_IMPORT_SERVICE_CLIENT_LOADING = 'POST_IMPORT_SERVICE_CLIENT_LOADING';
export const POST_IMPORT_SERVICE_CLIENT_SUCCESS = 'POST_IMPORT_SERVICE_CLIENT_SUCCESS';
export const POST_IMPORT_SERVICE_CLIENT_REJECT = 'POST_IMPORT_SERVICE_CLIENT_REJECT';

//* ACTIONS ------------------------------------------------
export const postImportServiceClientReset = () => ({ type: POST_IMPORT_SERVICE_CLIENT_RESET });
export const postImportServiceClientLoading = () => ({ type: POST_IMPORT_SERVICE_CLIENT_LOADING });
export const postImportServiceClientSuccess = (payload) => ({ type: POST_IMPORT_SERVICE_CLIENT_SUCCESS, payload });
export const postImportServiceClientReject = (payload) => ({ type: POST_IMPORT_SERVICE_CLIENT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postImportServiceClientRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        headers: RequestType.Multipart,
        data,
    }, getState);

    return request(`/Clients/web/AddClientServicesTemplateFile`, options);
};
